import { render, staticRenderFns } from "./TutorialModal.vue?vue&type=template&id=227aaa3e&scoped=true"
import script from "./TutorialModal.vue?vue&type=script&lang=js"
export * from "./TutorialModal.vue?vue&type=script&lang=js"
import style0 from "./TutorialModal.vue?vue&type=style&index=0&id=227aaa3e&prod&scoped=true&lang=css"
import style1 from "./TutorialModal.vue?vue&type=style&index=1&id=227aaa3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227aaa3e",
  null
  
)

export default component.exports